export default "__VITE_ASSET__DJOdOO6o__"